// src/utils/cloudinary.js

const CLOUD_NAME   = 'dvrxaw1bl';
const UPLOAD_PRESET = 'age_uploads'; // Cloudinary'de oluşturduğunuz unsigned preset adı

/**
 * Bir dosyayı Cloudinary'e yükler ve URL döner.
 * @param {File} file
 * @param {function} onProgress - (percent: number) => void
 * @returns {Promise<string>} secure_url
 */
export async function uploadToCloudinary(file, onProgress) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('folder', 'age-crm');

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`);

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const res = JSON.parse(xhr.responseText);
        resolve(res.secure_url);
      } else {
        reject(new Error('Yükleme başarısız: ' + xhr.statusText));
      }
    };

    xhr.onerror = () => reject(new Error('Ağ hatası'));
    xhr.send(formData);
  });
}
